(() => {
  if (window.minimumOrderCheckoutListenerAdded) return;
  window.minimumOrderCheckoutListenerAdded = true;

  const minimum = 3000; // Shopify-cartbedragen zijn in centen.
  const bypass = new WeakSet();
  const pending = new WeakSet();

  // De knoppen staan in twee verschillende formulieren. Submit afvangen werkt
  // ook voor toetsenbordgebruik en nadat Hyper de cart drawer opnieuw rendert.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (!(form instanceof HTMLFormElement) ||
        !button || button.name !== 'checkout' ||
        !(form.id === 'cart' || form.classList.contains('drawer__footer-buttons'))) return;

    if (bypass.has(form)) {
      bypass.delete(form);
      return;
    }

    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Kon winkelwagen niet ophalen');
      const cart = await response.json();

      if (cart.total_price < minimum) {
        const container = form.closest('cart-drawer, main-cart');
        const message = container?.querySelector('.minimum-order-message');
        if (message) {
          const remaining = minimum - cart.total_price;
          const remainingElement = message.querySelector('[data-minimum-order-remaining]');
          const formattedRemaining = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: cart.currency || 'EUR'
          }).format(remaining / 100).replace(/\s/g, '');

          if (remainingElement) remainingElement.textContent = formattedRemaining;
          message.hidden = false;
          message.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        return;
      }
    } catch (error) {
      // Shopify's verzendtarieven blijven de controle als de aanvraag faalt.
      console.warn('Controle minimale bestelwaarde niet beschikbaar:', error);
    } finally {
      pending.delete(form);
    }

    // Gebruik de originele submitknop, zodat Shopify de cart-formuliergegevens
    // en het checkout= veld op de normale manier verwerkt.
    bypass.add(form);
    form.requestSubmit(button);
  }, true);
})();
